import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import Input from "./input";
import InputArea from "./inputarea";
import Checkbox from "./checkbox";
import moment from "moment";
import Select from "../wms/select";
import { getDriven } from "./../../services/wms";
import { toast } from "react-toastify";
import Showimage from "./modalshowimage";
//import { saveRC } from "./../../services/wms";

const ZoomBhl = ({ isOpen, onConfirm, onCancel, list, branch }) => {
  const [startDate, setstartDate] = useState(new Date());
  const [seal1, setseal1] = useState("");
  const [seal2, setseal2] = useState("");
  const [seal3, setseal3] = useState("");
  const [seal4, setseal4] = useState("");
  const [remark, setremark] = useState("");
  const [webid, setwebid] = useState(0);
  const [rcid, setrcid] = useState(0);
  const [vForm, setvForm] = useState(false);
  const [chk1, setchk1] = useState(false);
  const [chk2, setchk2] = useState(false);
  const [chk3, setchk3] = useState(false);
  const [chk4, setchk4] = useState(false);
  const [chk5, setchk5] = useState(false);
  const [chk6, setchk6] = useState(false);
  const [step2, setstep2] = useState(false);
  const [message, setmessage] = useState("");
  const [message2, setmessage2] = useState("");
  const [branchid, setbranchid] = useState("");
  const [image1, setimage1] = useState();
  const [image2, setimage2] = useState();
  const [error, seterror] = useState("");

  const [askConfirm, setaskConfirm] = useState(false);
  const [trucklist, settrucklist] = useState([]);
  const [truckid, settruckid] = useState(0);
  const [disable, setdisable] = useState(false);
  const [time, settime] = useState(0);
  const [url, seturl] = useState("");
  const [isOpen1, setisOpen1] = useState(false);

  useEffect(() => {
    setbranchid(branch);
    if (list.length > 0) {
      const startime = new Date(list[0].starttime);
      setstartDate(startime);
      setwebid(list[0].AutoID);
      setrcid(list[0].RCID);
     // console.log(list[0])
      setremark(list[0].rccomment);
      settruckid(list[0].AXTruckCode);
      setimage1(list[0].imageurl1);
      setimage2(list[0].imageurl2);
      if (list[0].step2 === 1 && list[0].receive_weightnet !== "Waiting") {
      setdisable(true);
      } else {
        setdisable(false);
      }
      if (list[0].RCID === 0) {
        setchk1(true);
        if (list[0].checkpoint1 === 2) {
          setchk4(true);
        } else {
          setchk3(true);
        }
        if (list[0].checkpoint2 === 2) {
          setchk6(true);
        } else {
          setchk5(true);
        }
      } else if (list[0].RCID !== 0) {
        setchk1(true);
        if (list[0].checkpoint1 === 1) {
          setchk3(true);
        } else {
          setchk4(true);
        }
        if (list[0].checkpoint2 === 1) {
          setchk5(true);
        } else {
          setchk6(true);
        }
      }
      setseal1(list[0].Seal1);
      setseal2(list[0].Seal2);
      setseal3(list[0].Seal3);
      setseal4(list[0].Seal4);
      if (list[0].RCID !== 0 && list[0].Seal1 !== list[0].Seal2) {
        if (list[0].Seal2 === "") {
          setmessage("ยังไม่ระบุ seal ปลายทาง");
        } else {
          setmessage("เลข Seal ไม่ตรงกัน");
        }
      } else if (list[0].RCID === 0 && list[0].Seal1 !== list[0].Seal2) {
        setmessage("");
      } else {
        setmessage("");
      }

      if ( list[0].receive_weighnet == "Waiting"){
       // setdisable(true);
          }


      setvForm(true);
    } else {
      setrcid(0);
    }
  }, [list, branch]);

  useEffect(() => {
    if (!branch) return;

    const loadData = async () => {
      const { data: result } = await getDriven(branch, 2);

      if (result) {
        settrucklist(result);
      }
    };
    loadData();
  }, [branch]);

  //console.log(list)
  const handelClose = () => {
    setisOpen1(false);
  };
  const handleChangStartDate = (event) => {
    setstartDate(event);
  };

  const SaveData = () => {
    if (!seal1) {
      seterror("ยังไม่ระบุเลข seal ต้นทาง ");
      return;
    } else if (!seal2 && rcid !== 0) {
      seterror("ยังไม่ระบุเลข seal ปลายทาง ");
      return;
    } else if (truckid == 0) {
      seterror("กรุณาระบุ บริษัทบรรทุก");
      return;
    } else if (rcid == 0 && !image1) {
      seterror("กรุณา Capture รูปก่อนค่ะ");
      return;
    } else if (
      rcid !== 0 &&
      list &&
      list.length > 0 &&
      list[0].Weight_no == ""
    ) {
      seterror("ไม่พบเลขที่ใบชั่งไม่สามารถ zoom ปลายทางได้ค่ะ");
      return;
    } else if (rcid !== 0 && !image2) {
      seterror("กรุณา Capture รูปก่อนค่ะ");
      return;
    }

    let ImageData;
    if (rcid == 0) {
      ImageData = image1;
    } else {
      ImageData = image2;
    }

    if (ImageData.includes("data:image/png;base64,"))
      ImageData = ImageData.replace("data:image/png;base64,", "");
    if (ImageData.includes("data:image/jpg;base64,"))
      ImageData = ImageData.replace("data:image/jpg;base64,", "");
    if (ImageData.includes("data:image/jpeg;base64,"))
      ImageData = ImageData.replace("data:image/jpeg;base64,", "");

    // console.log(ImageData)
    doSubmit(ImageData);
  };

  //console.log(trucklist)

  const doSubmit = async (ImageData) => {
    try {
      const doc = {
        seal1,
        seal2,
        seal3,
        seal4,
        remark,
        chk1,
        chk2,
        chk3,
        chk4,
        chk5,
        chk6,
        webid,
        id: rcid,
        starttime: moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        axcode: truckid,
        branchid,
        imagedata: ImageData,
      };
      onConfirm(doc);
  // console.log(doc)

      // const { data: result } = await saveRC(doc);
      // if (result.status === "success") {
      //   toast.success("บันทึกเสร็จเรียบร้อย");
      //   onConfirm();
      // } else {
      //   toast.error(result.message);
      // }
    } catch (err) {
      toast.error("Error Try Catch");
    }
  };
  const onChangeSeal1 = (event) => {
    setseal1(event.currentTarget.value);
    seterror("");
    setmessage("");
  };
  const onChangeSeal2 = (event) => {
    setseal2(event.currentTarget.value);
    seterror("");
    setmessage("");
  };

  const onChangeSeal3 = (event) => {
    setseal3(event.currentTarget.value);
  };

  const onChangeSeal4 = (event) => {
    setseal4(event.currentTarget.value);
  };
  useEffect(() => {
    if (!branch) return;

    const loadData = () => {
      if (seal1 !== seal2 && rcid !== 0) {
        setmessage("เลข Seal ไม่ตรงกัน");
      } else if (!seal2) {
        setmessage("ยังไม่ระบุ seal ปลายทาง");
      } else if (!seal1) {
        setmessage("ยังไม่ระบุ seal ต้นทาง");
      } else {
        setmessage("");
      }
    };
    loadData();
  }, [branch, seal1, seal2, rcid]);

  useEffect(() => {
    if (!branch) return;

    const loadData = () => {
      if (seal3 !== seal4 && rcid !== 0) {
        setmessage2("เลข Seal ไม่ตรงกัน");
      } else if (!seal4) {
        setmessage2("ยังไม่ระบุ seal ปลายทาง");
      } else if (!seal3) {
        setmessage2("ยังไม่ระบุ seal ต้นทาง");
      } else {
        setmessage2("");
      }
    };
    loadData();
  }, [branch, seal3, seal4, rcid]);

  const onChangeChk1 = () => {
    setchk1(!chk1);
    if (!chk1) {
      setchk2(false);
    } else {
      setchk2(true);
    }
  };
  const onChangeChk2 = () => {
    setchk2(!chk2);
    if (!chk2) {
      setchk1(false);
    } else {
      setchk1(true);
    }
  };

  const onChangeChk3 = () => {
    setchk3(!chk3);
    if (!chk3) {
      setchk4(false);
    } else {
      setchk4(true);
    }
  };
  const onChangeChk4 = () => {
    setchk4(!chk4);
    if (!chk4) {
      setchk3(false);
    } else {
      setchk3(true);
    }
  };
  const onChangeChk5 = () => {
    setchk5(!chk5);
    if (!chk5) {
      setchk6(false);
    } else {
      setchk6(true);
    }
  };
  const onChangeChk6 = () => {
    setchk6(!chk6);
    if (!chk6) {
      setchk5(false);
    } else {
      setchk5(true);
    }
  };
  const onChangeRemark = (event) => {
    setremark(event.currentTarget.value);
  };
  const handleChangeVendorCode = (event) => {
    settruckid(event.currentTarget.value);
    seterror("");
  };

  document.onpaste = function (event) {
    var items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    // console.log(' json ',JSON.stringify(items)); // will give you the mime types

    for (var index in items) {
      var item = items[index];
      if (item.kind === "file") {
        var blob = item.getAsFile();
        var reader = new FileReader();

        reader.onload = function (event) {
          if (event.target.result.includes("image")) {
            if (
              branchid &&
              list &&
              list.length > 0 &&
              list[0].RCID == 0 &&
              rcid == list[0].RCID &&
              list[0].receive_weightin == "Waiting"
            ) {
              document.getElementById("image1").src = event.target.result;
              seterror("");
              setimage1(event.target.result);
              setimage2("");
            } else if (
              branchid &&
              list &&
              list.length > 0 &&
              list[0].RCID !== 0 &&
              rcid == list[0].RCID
            ) {
              seterror("");
              setimage2(event.target.result);
              document.getElementById("image2").src = event.target.result;
            }
            //cursor.urlImage = event.target.result;
            //    console.log(' result ', event.target.result); //
          }
        }; // data url!
        reader.readAsDataURL(blob);
      }
    }
  };
  // console.log(list);

  const handleClick = (id) => {
    if (id === 1 && image1) {
      seturl(image1);
      setisOpen1(true);
    } else if (id === 2 && image2) {
      seturl(image2);
      setisOpen1(true);
    }
  };
  return (
    <>
      <Showimage isOpen={isOpen1} onCancel={handelClose} list={url} />
      <div className="container">
        {/* <PopupAlert
            isOpen={messageErros.askAlert.enable}
            onOk={handlePopupAlertClick}
            message={messageErros.askAlert.message}
          /> */}
        {/* <ConfirmSubmit
            isOpen={askConfirm}
            onConfirm={handleConfirmSubmit}
            onCancel={handleCancleSubmit}
            message={message}
            button1="OK"
          /> */}
        <Modal
          className="m-2"
          show={isOpen}
          onHide={onCancel}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="d-flex justify-content-center bg-primary ">
            <div className="row ">
              <Modal.Title
                id="contained-modal-title-vcenter "
                className="text-white"
              >
                บันทึก/แก้ไข กิจกรรม ZOOM
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="ms-5">
            {list && list.length > 0 && (
              <>
                <div className="row">
                  <div className="col-lg-8  col-sm-8 col-xs-12">
                    <div className="row">
                      <h6 className="">ทะเบียนรถ :</h6>
                      <p className="ms-2"> {list[0].Driven_no} </p>
                    </div>
                    <div className="row">
                      <h6 className="">เลขที่ใบชั่ง :</h6>
                      <p className="ms-2">{list[0].Weight_no}</p>
                    </div>
                    <div className="row">
                      <h6 className="">ผรม.รถบรรทุก :</h6>
                      <Select
                        data={trucklist}
                        value={truckid}
                        textProperty="name"
                        valueProperty="id"
                        onChange={handleChangeVendorCode}
                      />
                    </div>
                    <div className="row">
                      <h6 className="me-2 mt-2 ">วันที่ออกจากต้นทาง :</h6>
                      <DatePicker
 className="datepicker-default form-control"
                        todayButton="Today"
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={handleChangStartDate}
                      />
                    </div>

                    <div className="row mt-4">
                      <h6 className=" mt-3 me-2">Seal หัว:</h6>
                      <div className="row">
                        <div className="col-lg-5  mt-2">
                          <Input
                            placeholder="Seal ต้นทาง"
                            name="seal1"
                            value={seal1}
                            onChange={onChangeSeal1}
                          />
                        </div>
                        <div className="col-lg-5  mt-2">
                          <Input
                            placeholder="Seal ปลายทาง"
                            name="seal2"
                            value={seal2}
                            onChange={onChangeSeal2}
                          />
                        </div>
                        {message && (
                          <div
                            className="col-lg-2 alert alert-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {message}
                          </div>
                        )}
                      </div>
                    </div>
                    {list &&
                      list.length > 0 &&
                      list[0].second_driven_no !== "" && (
                        <div className="row mt-4">
                          <h6 className=" mt-3 me-2">Seal หาง :</h6>
                          <div className="row">
                            <div className="col-lg-5  mt-2">
                              <Input
                                placeholder="Seal ต้นทาง"
                                name="seal3"
                                value={seal3}
                                onChange={onChangeSeal3}
                              />
                            </div>
                            <div className="col-lg-5  mt-2">
                              <Input
                                placeholder="Seal ปลายทาง"
                                name="seal4"
                                value={seal4}
                                onChange={onChangeSeal4}
                              />
                            </div>
                            {message2 && (
                              <div
                                className="col-lg-2 alert alert-danger"
                                style={{ fontSize: "12px" }}
                              >
                                {message2}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    <div className="row mt-4">
                      <h6 className=" me-5">
                        Activity : &nbsp;&nbsp; &nbsp;&nbsp;
                      </h6>
                      <span>
                        <Checkbox
                          name="id1"
                          value={chk1}
                          checked={chk1}
                          onChange={onChangeChk1}
                          label={"เริ่มกิจกรรม"}
                        />

                        <Checkbox
                          name="id2"
                          value={chk2}
                          checked={chk2}
                          onChange={onChangeChk2}
                          label={"ลบกิจกรรม"}
                        />
                      </span>
                    </div>
                    <div className="row mt-3">
                      <h6 className=" me-2">ตรวจสอบร้อยเชือก :</h6>

                      <span>
                        <Checkbox
                          name="id3"
                          value={chk3}
                          checked={chk3}
                          onChange={onChangeChk3}
                          label={"เรียบร้อย"}
                        />

                        <Checkbox
                          name="id4"
                          value={chk4}
                          checked={chk4}
                          onChange={onChangeChk4}
                          label={"ไม่เรียบร้อย"}
                        />
                      </span>
                    </div>
                    <div className="row mt-3">
                      <h6 className=" me-1">ตรวจสอบคลุมผ้าใบ :</h6>
                      <span>
                        <Checkbox
                          name="id5"
                          value={chk5}
                          checked={chk5}
                          onChange={onChangeChk5}
                          label={"เรียบร้อย"}
                        />

                        <Checkbox
                          name="id6"
                          value={chk6}
                          checked={chk6}
                          onChange={onChangeChk6}
                          label={"ไม่เรียบร้อย"}
                        />
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-4  col-sm-4 col-xs-12 mt-4">

                    <span className="d-flex justify-content-start">
                      <div className="mytooltip tooltip-effect-1">
                        <span className="tooltip-item">
                          {"zoom  ต้นทาง"}
                          <button onClick={() => handleClick(1)}>
                            <span className="d-none d-md-inline text-black pr-2">
                              <img
                                alt=""
                                id="image1"
                                className="rounded ms-2"
                                style={{ width: "150px", height: "150px" }}
                                src={image1}
                              />
                            </span>
                          </button>
                        </span>

                        {image1 && (
                          <span className="tooltip-content clearfix">
                            <img
                              alt=""
                              className="rounded ms-2"
                              src={image1}
                              style={{
                                width: "100%",
                                maxHeight: "300px",
                                maxWidth: "300px",
                              }}
                            />

                            <span className="tooltip-text"></span>
                          </span>
                        )}
                      </div>
                    </span>
                    <span className="d-flex justify-content-start mt-4">
                      <div className="mytooltip tooltip-effect-1">
                     
                          <span className="tooltip-item">
                          {"zoom ปลายทาง"}
                          <button onClick={() => handleClick(2)}>
                            <span className="d-none d-md-inline text-black pr-2">
                              <img
                                id="image2"
                                alt=""
                                className="rounded ms-2"
                                style={{ width: "150px", height: "150px" }}
                                src={image2}
                              />
                            </span>
                            </button>
                          </span>
                       

                        {image2 && (
                          <span className="tooltip-content clearfix">
                            <img
                              alt=""
                              className="rounded ms-2"
                              src={image2}
                              style={{
                                width: "100%",
                                maxHeight: "300px",
                                maxWidth: "300px",
                              }}
                            />

                            <span className="tooltip-text"></span>
                          </span>
                        )}
                      </div>
                    </span>
                  </div>
                </div>

                <div className="row me-4 mt-4">
                  <InputArea
                    label="หมายเหตุ"
                    name="remark"
                    value={remark}
                    onChange={onChangeRemark}
                  />
                </div>
              </>
            )}
          </Modal.Body>
          {error && (
            <div className="col-md-12 alert alert-danger"> {error}</div>
          )}
          <Modal.Footer className="me-4">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              ยกเลิก
            </button>
            <button
              disabled={disable}
              type="button"
              onClick={SaveData}
              className="btn btn-primary"
            >
              ยืนยัน
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default ZoomBhl;
